import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import categories from '../data/categories.json';
import fetchProducts from '../helper/fetchProducts';
import { Row, Col, Pagination } from 'antd';
import ProCard from '../components/ProCard';
import SkeletonProd from '../components/SkeletonProd';

const Collection = () => {
    const { url } = useParams();
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [products, setProducts] = useState([]);
    const [currentCategory, setCurrentCategory] = useState(null);

    useEffect(() => {
        const category = categories.find(item => item.url === url);
        setCurrentCategory(category);
    }, [url]);

    const getProducts = async () => {
        if (currentCategory) {
            setLoading(true);
            const temp = await fetchProducts(currentCategory.collections, page, 40);
            console.log("fetchProducts data:", temp); // Debugging
            const { Products, PageSize, TotalNumberOfProducts } = temp.data;

            console.log("TotalNumberOfProducts:", TotalNumberOfProducts); // Debugging
            console.log("PageSize:", PageSize); // Debugging

            const tempTotalPages = Math.ceil(TotalNumberOfProducts / PageSize);

            console.log("totalPages:", tempTotalPages); // Debugging

            setTotalPages(tempTotalPages);
            setProducts(Products);
            setLoading(false);
        }
    };

    useEffect(() => {
        getProducts();
    }, [currentCategory, page]);

    return (
        <section className="themeRing" id="montiter">
            <div className="container">
                <h1 style={{ textAlign: 'center' }} className="theme-h1">{currentCategory?.name}</h1>
                {loading ? (
                    <SkeletonProd />
                ) : (
                    <>
                        <Row gutter={[20, 20]}>
                            {Array.from(products).map((prod, index) => {
                                if (!prod) {
                                    return null;
                                }
                                return (
                                    <Col key={index} xs={24} sm={12} md={8} lg={6} xl={6}>
                                        <ProCard prod={prod} key={prod.sku} />
                                    </Col>
                                );
                            })}
                        </Row>
                        <Pagination
                            align="end"
                            current={page}
                            onChange={(val) => {
                                setPage(val);
                            }}
                            total={totalPages}
                        />
                    </>
                )}
            </div>
        </section>
    );
};

export default Collection;